import React from "react";

import { AppHeader } from "../AppHeader";

import { SearchPanel } from "../SearchPanel";

import PostStatusFilter from "../PostStatusFilter/PostStatusFilter";

import { PostList } from "../PostList/PostList";

import { PostAddForm } from "../PostAddForm/PostAddForm";

import "./App.css";

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          id: 1,
          label: "I have enough time to learn React JS",
          important: false,
          liked: false
        },
        {
          id: 2,
          label: "I feel freedom, with my all parts my body ",
          important: false,
          liked: false
        },
        {
          id: 3,
          label: "I am very good people in the world",
          important: false,
          liked: false
        },
      ],
      term: '',
      filter: 'all',
    }

    this.addItem = this.addItem.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.onToggleImoprtant = this.onToggleImoprtant.bind(this)
    this.onToggleLiked = this.onToggleLiked.bind(this)
    this.onUpdateSearch = this.onUpdateSearch.bind(this)
    this.searchPost = this.searchPost.bind(this)
    this.onFilterSelect = this.onFilterSelect.bind(this)

    this.maxId = 4
  }

    deleteItem(id) {
      this.setState(({ data }) => {
        const index = data.findIndex((elem) => elem.id === id);

        const before = data.slice(0, index),
          after = data.slice(index + 1);

        const newArr = [...before, ...after];

        return {
          data: newArr,
        };
      });
    }

    addItem(body) {
        const newItem = {
            id: this.maxId++,
            label: body,
            important: false,
            liked: false
        }

        this.setState(({ data }) => {
            const newArr = [...data, newItem]
            return {
                data: newArr
            }
        })
    }

    onToggleImoprtant(id) {
        this.setState(({data}) => {
            const index = data.findIndex(element => element.id === id)

                const oldItem = data[index]

                const newItem = {
                    ...oldItem,
                    important: !oldItem.important
                }

            const newArr = [...data.slice(0, index), newItem, ...data.slice(index + 1)]

            return {
                data: newArr
            }
        })
    }

    onToggleLiked(id) {
        this.setState(({data}) => {
            const index = data.findIndex(element => element.id === id)

                const oldItem = data[index]

                const newItem = {
                    ...oldItem,
                    liked: !oldItem.liked
                }

            const newArr = [...data.slice(0, index), newItem, ...data.slice(index + 1)]

            return {
                data: newArr
            }
        })
    }

    onUpdateSearch(term) {
      this.setState({term})
    }

    filterPost(items, filter) {
        if (filter === 'liked') {
            return items.filter(item => item.liked)
        }
        else {
          return items
        }
    }

    onFilterSelect(filter) {
      this.setState({filter})
    }

    searchPost(items, term) {
      if (term.length === 0) {
          return items
      }

      return items.filter(item => {
          return item.label.indexOf(term) > -1
      })
    }

    render() {
        const { data, term, filter } = this.state
        const liked = data.filter(item => item.liked).length
        const allPosts = data.length
        const visiblePosts = this.filterPost(this.searchPost(data, term), filter)

        return (
            <div className="App">
                <AppHeader liked={ liked } allPosts={ allPosts } />

                <div className="search-filter-panel d-flex">
                    <SearchPanel onUpdateSearch={ this.onUpdateSearch } />
                    <PostStatusFilter filter={ filter } onFilterSelect={this.onFilterSelect  } />
                </div>

                <PostList
                    posts={ visiblePosts } 
                    deleteItem={this.deleteItem}
                    onToggleImoprtant={ this.onToggleImoprtant }
                    onToggleLiked={ this.onToggleLiked }
                />

                <PostAddForm onAdd={this.addItem} />
            </div>
        )
    }
}

